<template>
    <div>
        <label class="label scope"
               v-if="$store.getters.scopes[id]"
               v-for="id in internalValue"
               v-bind:style="{background:$store.getters.scopes[id].color}"
               :title="$store.getters.scopes[id].name">{{ $store.getters.scopes[id].slug.substr(0,1) }}</label>
    </div>
</template>

<script>
    export default {
        name: 'Scopes',
        props: ['value','label','name','placeholder'],
        data: function () {
            return {
                internalValue: ''
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Scopes.vue